import { FaPeopleRoof } from "react-icons/fa6";
import images from "./images";

const About = {
    sub: "About Us",
    heading: "Your Trusted Source for Professional Roofing Services",
    description: [
        "Welcome to RoofGuard, your go-to destination for top-notch roofing solutions. We are dedicated to providing exceptional craftsmanship and services that enhance the protection, durability, and appearance of your property. With decades of industry experience, our team is committed to ensuring your roofing needs are met with precision and care."
    ],
    experience: {
        icon: <FaPeopleRoof />,
        year: 35,
        text: 'years of experience',
    },
    points: [
        "Comprehensive Roof Installation",
        "Expert Roof Repairs",
        "High-Quality Materials",
        "Precision Craftsmanship",
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        alt1: "About-Image1",
        alt2: "About-Image2",
    },
    button: {
        text: "Contact Us",
        link: "Contact-us"
    }
};

export default About;